// extracted by mini-css-extract-plugin
module.exports = {"inputWr":"InputWithReadOnlyTextPart_inputWr__1jPEJ","readOnlyPart":"InputWithReadOnlyTextPart_readOnlyPart__3KtD7"};